import Component from "@lib/Component.js";
import { addEvent, addClass, removeClass } from "@qneyraud/q-utils/umd/q-utils";
const POSSIBLE_EVENTS = ["change"];

const octetToMo = (v) => v / 1024 / 1024;

export default class Input extends Component {
  init() {
    super.init();
    this.bindMethods();

    this.events = {};
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    if (this.datas.type === "file") {
      this.typeFileBehavior();
    }
    if (this.datas.type === "textarea") {
      this.typeTextareaBehavior();
    }
    if (this.datas.type === "select") {
      this.typeSelectBehavior();
    }

    addEvent(this.refs.input, "focus", this.onInputFocus);
  }

  bindMethods() {
    this.onInputFileChange = this.onInputFileChange.bind(this);
    this.onInputKeypress = this.onInputKeypress.bind(this);
    this.onFilesListClick = this.onFilesListClick.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.addFile = this.addFile.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
  }

  /**
   * Events
   */
  on(eventType, cb) {
    if (!POSSIBLE_EVENTS.indexOf(eventType) === -1) {
      console.warn(eventType + " non accepté");
    }

    if (!this.events[eventType]) this.events[eventType] = [];

    this.events[eventType].push(cb);
  }

  off(eventType, cb) {
    if (!this.events[eventType]) return;

    this.events[eventType] = this.events[eventType].filter((eventCb) => eventCb !== cb);
  }

  emit(eventType, datas) {
    this.events[eventType] && this.events[eventType].forEach((cb) => cb(datas));
  }

  /**
   * Type file
   */

  typeFileBehavior() {
    this.files = [];

    addEvent(this.refs.input, "change", this.onInputFileChange);
    addEvent(this.refs.fileslist, "click", this.onFilesListClick);
  }

  onInputFileChange(e) {
    Array.from(e.target.files).forEach(this.addFile);
  }

  onInputFileClick() {
    this.refs["input"].value = null;
  }

  addFile(file) {
    if (this.files.length >= parseInt(this.datas.maxFiles)) return;
    if (this.datas.maxSize && octetToMo(file.size) > this.datas.maxSize) return;

    // Uid
    const uid =
      "_" +
      Math.random()
        .toString(36)
        .substr(2, 9);

    // DOM
    const dom = document.createElement("button");
    dom.dataset.uid = uid;
    addClass(dom, "file");
    dom.innerHTML = `
      <div class="icon"></div>
      <span>${file.name}</span>
    `;
    this.refs["fileslist"].appendChild(dom);

    // mirror
    this.files.push({
      file,
      dom,
      uid
    });
  }

  removeFile(file) {
    const index = this.files.findIndex((f) => f === file);
    if (index > -1) {
      // DOM
      this.refs["fileslist"].removeChild(file.dom);

      // mirror
      this.files.splice(index, 1);
    }
  }

  getFileByUid(uid) {
    return this.files.find((file) => file.uid === uid);
  }

  onFilesListClick(e) {
    e.preventDefault();

    if (e.target.classList.contains("file")) {
      const uid = e.target.dataset.uid;

      const file = this.getFileByUid(uid);

      if (file) {
        this.removeFile(file);
      }
    }
  }

  /**
   * Type textarea
   */

  typeTextareaBehavior() {
    addEvent(this.refs.input, "keypress", this.onInputKeypress);
  }

  onInputKeypress() {
    if (this.refs.input.scrollHeight > this.refs.input.clientHeight) {
      this.el.style.height = this.el.clientHeight + 200 + "px";
    }
  }

  /**
   * Type select
   */

  typeSelectBehavior() {
    addEvent(this.refs.input, "change", this.onSelectChange);
  }

  onSelectChange() {
    const selectedText = this.refs.input.options[this.refs.input.selectedIndex].innerText;
    if (this.datas.selectPrefix) {
      this.refs.label.innerText = `${this.datas.selectPrefix} : ${selectedText}`;
    } else {
      this.refs.label.innerText = selectedText;
    }

    this.emit("change", this.refs.input.value);
  }

  /**
   * Type submit
   */

  showLoading() {
    addClass(this.el, "submit-pending");
  }

  hideLoading() {
    removeClass(this.el, "submit-pending");
  }

  /**
   * Common
   */

  validate() {
    if (this.datas.type === "checkbox") return this.refs["input"].checkValidity() && this.validateCheckbox();

    return this.refs["input"].checkValidity();
  }

  validateCheckbox() {
    if (this.datas.required && this.getValue() === false) return false;

    return true;
  }

  getValue() {
    if (this.datas.type === "file") return this.files;
    if (this.datas.type === "checkbox") return this.refs.input.checked;
    return this.refs.input.value;
  }

  clear() {
    if (this.datas.type === "file") {
      this.files.forEach((file) => this.removeFile(file));
    }

    if (this.datas.type === "checkbox") {
      this.refs.input.checked = false;
    }

    if (this.datas.type === "select") {
      this.refs.input.selectedIndex = 0;
      this.onSelectChange();
    }

    this.refs.input.value = "";
  }

  setError(errorMessage) {
    addClass(this.el, "has-error");

    this.refs.error.innerText = errorMessage;
  }

  onInputFocus() {
    removeClass(this.el, "has-error");
    this.refs.error.innerText = "";
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Input.js